import { HttpRequestData, httpUtil, PaginationResponse  } from '@esg/framework';
import { getEnv, PaginationRequest } from '@esg/shared';

export interface GetAppointmentsRequest extends HttpRequestData {
    readonly query: PaginationRequest & {
        startTime?: string;
        endTime?: string;
        branchId?: string;
    };
}

export interface AppointmentItem {
    customerId: string;
    appointmentDate: string;
}

export const getAppointments = httpUtil.createHttpRequestMeta<
    GetAppointmentsRequest,
    PaginationResponse<AppointmentItem>
>({
    baseUrl: () => getEnv().AGENCY_SERVER,
    path: '/api/v1/appointments',
    method: 'GET',
    authentication: 'bearer',
});